<template>
  <div id="ConfigCachePurgeAll">
    <b-row class="pt-3">
      <b-col class="new-config">
        <b-form id="cache-form" class="new-test-form">
          <b-form-row class="submit">
            <b-col cols="12" sm="12" class="d-flex">
              <b-button type="button" variant="danger" size="lg" :disabled="isLoading" v-b-modal.dump-modal>Dump everything</b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <b-modal id="dump-modal" header-text-variant="danger" centered title="Caution!" @ok="dump">
      <p class="mt-4">This will remove everything cached in Webapi.</p>
      <p class="mb-4">That may cause;</p>
      <ul>
        <li>Longer response time for some users.</li>
        <li>Down time if BE is not available</li>
      </ul>
      <p class="my-4 text-danger">Use only if it is necessary</p>
    </b-modal>
  </div>
</template>

<script>
import { sweepAll } from '@/api/web'
export default {
  name: 'ConfigCachePurgeAll',
  methods: {
    dump () {
      sweepAll()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/config/ConfigCachePurgeAll.vue